<template>
    <Resize id="app" class="app-layout">
        <!-- <Test /> -->
        <!-- <Delete /> -->
        <Signup />
    </Resize>
</template>

<script>
    // import { mapGetters } from 'vuex';
    import Resize from './components/1-common/Resize';
    import Signup from '@/components/3-pages/Signup';
    import Delete from '@/components/3-pages/Delete';
    import Test from '@/components/3-pages/Test';

    export default {
        name: 'app',
        components: {
            Resize,
            Signup,
            Delete,
            Test
        }
    };
</script>







// WEBPACK FOOTER //
// App.vue?70e57514